/**
 * AppLayout - Shared Layout Component for ALL LoanKnow Portals
 * Now delegates to the new Shell (top-nav) layout system.
 * This wrapper preserves the existing API so all portal routes work unchanged.
 */
import Shell from '../../ui/Shell';

const AppLayout = ({ 
  role, 
  navItems, 
  user, 
  onLogout,
  children 
}) => {
  return (
    <Shell
      role={role}
      navItems={navItems}
      user={user}
      onLogout={onLogout}
    >
      {children}
    </Shell>
  );
};

export default AppLayout;
